const SegmentedControl = ({ options = [], value, onChange, ariaLabel }) => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className="inline-flex items-center gap-1 rounded-[var(--radius-md)] border border-[var(--border)] bg-[var(--muted)] p-1 shadow-[var(--shadow-xs)]"
  >
    {options.map((opt) => {
      const active = opt.value === value
      return (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange?.(opt.value)}
          className={`rounded-[var(--radius-sm)] px-3 py-1.5 text-[0.8125rem] font-medium transition-colors ${
            active
              ? 'bg-[var(--card)] text-[var(--primary)] shadow-[var(--shadow-xs)]'
              : 'text-[var(--muted-foreground)] hover:text-[var(--foreground)]'
          }`}
        >
          {opt.label}
        </button>
      )
    })}
  </div>
)

export default SegmentedControl
